import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';
import produce from "immer";
import { useNotificationCountQuery } from '@data/notification/notification.query';

interface totalCountState {
  notifications: number;
  loading: boolean;
}

const initialState: totalCountState = {
  notifications: 0,
  loading: false,
}

export const initData = createAsyncThunk('totalCounts/init', async (_params, { dispatch })  => {
  // const { data } = await Base.get(API_ENDPOINTS.TOTAL_COUNT_HEADER);
  const {
      data,
    } = useNotificationCountQuery();
  dispatch(setNotifications({notifications: data}));
  return data;
})

export const totalCountSlice = createSlice({
  name: 'totalCounts',
  initialState,
  reducers: {
    totalCountClear: () => initialState,
    setNotifications: (state, { payload }) => {
      state.notifications = payload.notifications
    }
  },
  extraReducers: (builder) => {
    builder.addCase(initData.pending, () => {
      return produce(initialState, draft => { draft.loading = true; });
    }),
    builder.addCase(initData.fulfilled, (state, { payload }) => {
      return produce(state, draft => {
        draft.notifications = payload.notifications;
        draft.loading = true;
      });
    }),
    builder.addCase(initData.rejected, (state) => {
      return produce(state, draft => { draft.loading = false; });
    })
  },
})

export const {
  totalCountClear,
  setNotifications,
} = totalCountSlice.actions

export default totalCountSlice.reducer
